<script lang="ts">
  import Star from '$lib/components/images/LogoStar.svelte'

  interface Props {
    top?: boolean
    spacing?: 'default' | 'after-hero'
  }

  let { top = false, spacing = 'default' }: Props = $props()
</script>

<div class="separator spacing-{spacing}" class:top>
  <Star />
</div>

<style lang="postcss">
  .separator {
    --_line-thickness: 3px;
    --_color: var(--separator-color, var(--color-bg-success-secondary));
    --_size: 3.5rem;
    display: block;
    position: relative;
    margin: var(--size-content-py) auto;
    height: var(--_line-thickness);

    &.spacing-after-hero {
      margin-top: calc(var(--_size) / 2);
    }

    &.top {
      position: absolute;
      top: calc((var(--size-content-py)) * -1 - 26px);
      right: 0;
      left: 0;
    }

    &:before,
    &:after {
      --_from-center: calc(50% + var(--_size));
      position: absolute;
      border-radius: var(--radius-full);
      background: var(--_color);
      width: min(20%, 10rem);
      height: 100%;
      content: '';
    }
    &:before {
      right: var(--_from-center);
    }
    &:after {
      left: var(--_from-center);
    }

    & :global(svg) {
      display: block;
      position: absolute;
      top: calc(-1 * (var(--_size) / 2) + var(--_line-thickness) / 2);
      left: calc(50% - var(--_size) / 2);
      width: 3.5rem;
      height: 3.5rem;

      color: var(--_color);
    }
  }
</style>
